import { useEffect, useState } from 'react';
import { useConfig } from '@common/Hooks/useConfig';
import { handleTracking } from '../helpers/handleTracking';
import { useNavigationStateHandler } from './useNavigationStateHandler';

export const useClickHandlers = (navigation, uuids) => {
    const config = useConfig();
    let newUuids = config.uuidPath === undefined ? uuids : config.uuidPath;

    // Strip path to the second lvl
    if (newUuids.length > 3) {
        newUuids = newUuids.slice(0, 3);
    }

    const { navigationStateFromPath } = useNavigationStateHandler(navigation);
    const [navigationState, setNavigationState] = useState(navigationStateFromPath(newUuids, undefined));

    const newUuidsCheckSum = newUuids.join('');

    useEffect(() => {
        if (newUuids.length > 0) {
            setNavigationState(navigationStateFromPath(newUuids, undefined));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newUuidsCheckSum]);

    const navItemClick = (navigationPath, isBackBtnClick) => {
        setNavigationState(navigationStateFromPath(navigationPath, undefined, isBackBtnClick));
    };

    const storeSelectClick = (stores) => {
        setNavigationState(stores);
        handleTracking(config);
    };

    const languageSelectClick = (langs) => {
        setNavigationState(langs);
        handleTracking(config);
    };

    return (
        [navigationState, navItemClick, storeSelectClick, languageSelectClick]
    );
};
